const RefreshToken_mutate = `
    mutation RefreshToken($refreshToken: String!) {
	  refreshToken(refreshToken: $refreshToken) {
		token
		payload
		refreshToken
		refreshExpiresIn
	  }
	}
`;

const ForgetPassword_mutate = `
    mutation forgetPassword(
      $email: String!) {
      forgetPassword(
        email: $email) {
        userId
		email
      }
    }
`;

const ResetPassword_mutate = `
    mutation resetPassword(
      $password: String!,
	  $forgetCode: String!) {
      resetPassword(
        password: $password,
		forgetCode: $forgetCode) {
        userId
      }
    }
`;

const ChangePassword_mutate = `
  mutation changePassword(
    $email: String!,
    $password: String!) {
      changePassword(
        email: $email,
        password: $password,
      ) {
        userId
        password
      }
    }
`;

const ChangeEmail_mutate = `
  mutation changeEmail(
    $tenantName: String!,
    $contactEmail: String!,
    $firstName: String!,
    $lastName: String!,
    $email: String!,
    $newEmail: String!,
    $userType: String) {
      changeEmail(
        tenantName: $tenantName,
        contactEmail: $contactEmail,
        firstName: $firstName,
        lastName: $lastName,
        email: $email,
        newEmail: $newEmail,
        userType: $userType,
      ) {
        userId
        newEmail
      }
    }
`;

const ActivatePublicUser_mutate = `
    mutation activatePublicUser(
      $password: String!,
      $activationCode: String!) {
      activatePublicUser(
        password: $password,
        activationCode: $activationCode) {
        userId
      }
    }
`;

const ActivateTenantUser_mutate = `
    mutation activateTenantUser(
      $password: String!,
      $activationCode: String!) {
      activateTenantUser(
        password: $password,
        activationCode: $activationCode) {
        userId
      }
    }
`;

const ActivateUser_mutate = `
    mutation activateUser($activationCode: String!) {
      activateUser(activationCode: $activationCode) {
        userId
       activationCode
      }
    }
`;

const CreateTenantUser_mutate = `
    mutation createTenantUser(
      $firstName: String!, 
      $lastName: String!,
      $email: String!,
      $phoneNo: String,
      $city: String,
      $state: String, 
      $country: String,
      $tenantId: Int!,
      $groups: [String!]!,
      ) {
      createTenantUser(
        firstName: $firstName,        
        lastName: $lastName
        email: $email,
        phoneNo: $phoneNo,
        city: $city,        
        state: $state,
        country: $country
        tenantId: $tenantId,
        groups: $groups,) {
            userId
            firstName
            lastName
            email
            phoneNo
            city
            state
            country
            tenantId
            groups
        }
    }
`;

const GetUserDataByActivationCode_query = `
  query( $activationCode: String!)
  {
    getUserDataByActivationCode(activationCode: $activationCode)
    {
      firstName
      lastName
    }
  }    
`;

const UpdateUserIsActive = `mutation updateUserIsactive($userId:Int!, $isActive: Boolean!){
  updateUserIsactive(
    userId: $userId,
    isActive: $isActive
  ){
    response
  }
}`;

const TenantUserListByTermAndTeam = `
  query ( $tenantId: Int!
          $teamTermId: Int!
          $termId: Int!)
  {
    getTenantUsersByTermAndTeam(
      tenantId: $tenantId,
      teamTermId: $teamTermId,
      termId: $termId
    )
    {
      tenantUser
      {
        tenantUserId
        isTenantAdmin 
        tenantId
        {
          tenantId
        }
        userId
        {
          id
          firstName
          lastName
        }
        noOfTerms
      }
      selected
      roleName
      disabled
      teamTermMembers
      {
        roleId
        {
          roleId
          roleName
        }
        teamTermId
        {
          teamTermId
          teamId
          {
            name
          }
          termId{
            termId
            termUuid
            name
          }
        }
      }
    }
  }
`;

const StaffModules = `
  query ( $tenantUserId: Int!
          $clientId: Int!
          )
  {
    getStaffModules(
      tenantUserId: $tenantUserId,
      clientId: $clientId
    )
  {
    module    
    modulepages
  }
}
  `;

const StaffModuleAccess = `
  query ( $tenantUserId: Int!
          $clientId: Int!
          $moduleName: String!
          $modulepageName: String!
          )
  {
    staffModuleAccess(
      tenantUserId: $tenantUserId,
      clientId: $clientId,
      moduleName: $moduleName,
      modulepageName: $modulepageName
    )
  {
    access
    commonActions
    additionalActions
    
  }
}
  `;

const StaffClients = `
  query ( $tenantUserId: Int!
          )
  {
    getStaffClients(
      tenantUserId: $tenantUserId
    )
  {
    clientId
    name
  }
}
  `;

  const GetStaffClientCombinedGroupsPermissions_query = `
    query( $clientId: Int!
           $username: String!
           $tenantId: Int!)
    {
      getStaffClientCombinedGroupsPermissions(clientId:$clientId,username:$username,tenantId:$tenantId)
      {
          moduleId
          name
  
          modulepage
          {
            moduleId
            {
              moduleId
            }
            modulepageId
            name
            actionCommonName
            actionAdditionalName
          }
          groupModulepageAction
          {
            groupModulepageActionId
            modulepageId
            
            access
            actionCommonPermission
            actionAdditionalPermission
            
          }       
      }
    }
`;

const GetUserDataByEmail_query = `query($email: String!){
  getUserDataByEmail(email: $email){
    firstName
    lastName
  }
}`;

const getStaffClientsByUsername = `query($username: String!){
  getStaffClientsByUsername(username: $username){
    clientId
    name
  }
}`;

const getStaffTermsOfClient_query = `query(
    $username: String!
    $clientId: Int!
  ){
  getStaffTermsOfClient(
    username: $username,
    clientId: $clientId){
        teamTermMemberId
        teamTermId
        {
            teamTermId
            termId{
                termId
                termUuid
                name
                startDate
                endDate
            }
            teamId
            {
                teamUuid
                name
            }
        }
        userId{
          firstName
          lastName
        }
        roleId{
          roleName
        }
    }
}`;

module.exports = {
  REFRESH_TOKEN_MUTATION: RefreshToken_mutate,
  FORGET_PASSWORD_MUTATION: ForgetPassword_mutate,
  CHANGE_PASSWORD_MUTATION: ChangePassword_mutate,
  CHANGE_EMAIL_MUTATION: ChangeEmail_mutate,
  RESET_PASSWORD_MUTATION: ResetPassword_mutate,
  ACTIVATE_USER_MUTATION: ActivateUser_mutate,
  ACTIVATE_PUBLICUSER_MUTATION: ActivatePublicUser_mutate,
  CREATE_TENANT_USER_MUTATION: CreateTenantUser_mutate,
  ACTIVATE_TENANTUSER_MUTATION: ActivateTenantUser_mutate,
  GET_USER_DATA_BY_ACTIVATION_CODE_QUERY: GetUserDataByActivationCode_query,
  UPDATE_USER_ISACTIVE: UpdateUserIsActive,
  TENANT_USER_LIST_BY_TERM_TEAM: TenantUserListByTermAndTeam,
  STAFF_MODULES_QUERY: StaffModules,
  STAFF_CLIENTS_QUERY: StaffClients,
  STAFF_MODULE_ACCESS_QUERY: StaffModuleAccess,
  GET_USER_DATA_BY_EMAIL_QUERY: GetUserDataByEmail_query,
  GET_STAFF_CLIENTS_BY_STAFF_Uuid_QUERY: getStaffClientsByUsername,
  GET_STAFF_CLIENT_COMBINED_GROUPS_PERMISSIONS_QUERY: GetStaffClientCombinedGroupsPermissions_query,
  GET_STAFF_TERMS_OF_CLIENT_QUERY: getStaffTermsOfClient_query,
};
